export default function(item, name, retval) {
  if (item) {
    var df = this.context.dataflow,
        target = item.mark.source;
    df.pulse(target, df.changeset().encode(item, name));
  }
  return retval !== undefined ? retval : item;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-parser/src/parsers/expression/encode.js
// module id = 1420
// module chunks = 0